
import { mapState } from "vuex";
import { defineComponent } from "vue";
import ChatBotLinks from "@/components/ChatBotLinks.vue";
import MessengerDownloadLinks from "@/components/MessengerDownloadLinks.vue";
import MobileAppsLinks from "@/components/MobileAppsLinks.vue";
import AppLinkButton from "@/components/AppLinkButton.vue";
import store from "@/store";

export default defineComponent({
  name: "HomeView",
  components: {
    MobileAppsLinks,
    AppLinkButton,
    ChatBotLinks,
    MessengerDownloadLinks,
  },
  computed: {
    ...mapState([
      "showMobileLinks",
      "showDownloadLinks",
      "showPayLink",
      "homeViewTitle",
    ]),
  },
  methods: {
    toPayService: () => {
      store.dispatch("goToPayService");
    },
  },

  mounted() {
    const selectedChatBot = JSON.parse(
      localStorage.getItem("selectedChatBot") ||
        JSON.stringify({
          name: "",
          img: "",
          url: "",
          env: "",
        })
    );
    store.commit("SET_SELECTED_BOT", selectedChatBot);
    store.dispatch("generateChatBotLinksData");
  },
});
